import { createRoot } from "react-dom/client";
import { NuqsAdapter } from "nuqs/adapters/react-router";
import App from "./App.tsx";
import "./index.css";
import {
  backButton,
  init,
  mainButton,
  miniApp,
  popup,
  swipeBehavior,
  themeParams,
} from "@tma.js/sdk-react";

try {
  init();
  miniApp.mount();
  backButton.mount();
  mainButton.mount();
  themeParams.mount();
  popup.isSupported();
  swipeBehavior.mount();
  if (swipeBehavior.isSupported()) {
    swipeBehavior.disableVertical();
  }
} catch (e) {
  console.warn("TMA SDK init warning:", e);
}

try {
  window.Telegram?.WebApp?.ready();
  window.Telegram?.WebApp?.expand();
  window.Telegram?.WebApp?.disableVerticalSwipes?.();
} catch {
  // ignore
}
createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <NuqsAdapter>
    <App />
  </NuqsAdapter>,
  // </StrictMode>,
);
